import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { flatten, flattenDeep, isString, isUndefined, map, omitBy } from "lodash"
import { TerminalType } from "../graphql/types"
import { recursion } from "./helpers"

export const capitalize = (input: Maybe<string>): Maybe<string> =>
    input ? input.charAt(0).toUpperCase() + input.slice(1) : input

export const composeFullName = (firstName: Maybe<string>, surname: Maybe<string>, shortenSurname?: boolean): string => {
    const firstPart = firstName ? firstName + " " : ""
    const secondPart = shortenSurname && surname ? surname?.charAt(0) + "." : surname || ""
    return firstPart + secondPart
}

export const getRandRange = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

export const getKeyValuesRecursively = (arr: Record<string, any>[], keyName: string): string[] => {
    return flatten(
        arr.map(obj => {
            return obj.children ? [obj[keyName], ...getKeyValuesRecursively(obj.children, keyName)] : [obj[keyName]]
        })
    )
}

export const sortBoolean = (a: boolean, b: boolean) => {
    if (a === b) {
        return 0
    } else if (a) {
        return -1
    } else {
        return 1
    }
}

export const toDecimalPlaces = (num: number, places: number) => {
    return Math.round(num * 10 ** places) / 10 ** places
}

export const removeUndefinedKeys = (obj: Record<string, any>): Record<string, any> => omitBy(obj, isUndefined)

export const trimString = (str: Maybe<string>): Maybe<string> => {
    if (str) {
        return str.trim().replace(/\u00A0/g, " ")
    }

    return null
}

const serviceTypes = [
    TerminalType.Register,
    TerminalType.Mpos,
    TerminalType.Kiosk,
    TerminalType.Kds,
    TerminalType.Mib,
    TerminalType.Aggregator,
]

export const sortTerminals = (a: any, b: any): number => {
    if (a.entityType === "terminal" && b.entityType === "terminal" && a.type !== b.type) {
        return serviceTypes.indexOf(a.type) - serviceTypes.indexOf(b.type)
    }

    if (!isString(a.name) || !isString(b.name)) {
        return 0
    }

    return a.name.localeCompare(b.name)
}

export const sortString = (a: string, b: string): number => {
    if (!isString(a) || !isString(b)) {
        return 0
    }

    return a.localeCompare(b)
}

export const expandAllIds = (data: any[]): string[] =>
    flattenDeep(
        map(
            data,
            recursion((callSelf, record) => [record.id, flatten(map(record.children, callSelf))])
        )
    )
